import React from "react";
import { Input, Dropdown, Option } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import GenerateAudioContainer from "../../../Containers/GenericContainer/GenerateAudioContainer";
import "../../CSS/SurveyComponent.css";

export default function QuestionComponent({
  question,
  questionName,
  setCallCenterData,
  callFlowId,
  callFlowLanguage,
  audioList,
}) {
  const { t } = useTranslation();

  const surveyTypes = [
    { key: "YES_OR_NO", label: t("yesOrNo") },
    { key: "RATING", label: t("rating") },
    { key: "NUMERICAL", label: t("numerical") },
  ];

  const setField = (field, value) => {
    setCallCenterData((prev) => ({
      ...prev,
      survey: {
        ...prev.survey,
        questions: {
          ...prev.survey.questions,
          [questionName]: {
            ...prev.survey.questions[questionName],
            [field]: value,
          },
        },
      },
    }));
  };

  const setAudio = (audio) => {
    setCallCenterData((prev) => ({
      ...prev,
      survey: {
        ...prev.survey,
        questions: {
          ...prev.survey.questions,
          [questionName]: {
            ...prev.survey.questions[questionName],
            audio,
          },
        },
      },
    }));
  };

  return (
    <div className="question-fields">
      {/* Type */}
      <div className="question-row">
        <div className="question-label">{t("type")}</div>
        <Dropdown
          value={
            surveyTypes.find((t) => t.key === question?.type)?.label || ""
          }
          onOptionSelect={(e, data) => {
            const selectedType = surveyTypes.find(
              (t) => t.label === data.optionValue
            );
            if (selectedType) setField("type", selectedType.key);
          }}
        >
          {surveyTypes.map((type) => (
            <Option key={type.key} value={type.label}>
              {type.label}
            </Option>
          ))}
        </Dropdown>
      </div>

      {/* Question Text */}
      <div className="question-row">
        <div className="question-label">{t("questionText")}</div>
        <Input
          value={question?.questionText || ""}
          onChange={(e, data) => setField("questionText", data.value)}
        />
      </div>

      {/* Question Order */}
      <div className="question-row">
        <div className="question-label">{t("questionOrder")}</div>
        <Input
          type="number"
          value={question?.Order || ""}
          onChange={(e, data) => setField("Order", data.value)}
        />
      </div>

      {/* Audio */}
      <div className="question-row">
        <div className="question-label">{t("announcement")}</div>
        <GenerateAudioContainer
          setLangue={() =>
            setAudio({
              ...question.audio,
              type: "text2speech",
              language: callFlowLanguage,
            })
          }
          setDelete={() =>
            setAudio({
              type: "text2speech",
              audioFileUrl: "",
              text: "",
              selectedMedia: null,
            })
          }
          saveAudio={(url) =>
            setAudio({ ...question.audio, audioFileUrl: url })
          }
          setText={(text) =>
            setAudio({
              ...question.audio,
              text,
              audioFileUrl: "",
              type: "text2speech",
            })
          }
          setAudio={(selectedMedia) =>
            setAudio({
              ...question.audio,
              selectedMedia,
              audioFileUrl: selectedMedia?.url || "",
              text: "",
              type: "Audiofile",
            })
          }
          setType={(type) => setAudio({ ...question.audio, type })}
          audioFileUrl={question?.audio?.audioFileUrl || ""}
          fileName={question?.audio?.selectedMedia?.header}
          type={question?.audio?.type || "text2speech"}
          text={question?.audio?.text || ""}
          path={`survey/${questionName}`}
          defaultLanguage={question?.audio?.language || callFlowLanguage}
        />
      </div>
    </div>
  );
}
